import styled from "styled-components";
import Globais from "../../components/Globais";
import { Card, Steps } from "antd";

export const Container = styled.section`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 20px;
  justify-content: flex-start;
  align-items: center;

  @media (max-width: 768px) {
    height: auto;
    padding: 16px;
  }

  @media (max-width: 480px) {
    padding: 5px;
  }
`;

export const ContainerTitulo = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
`;
export const TituloLista = styled.h2`
  text-align: center;
  color: ${Globais.CorVerde};
  font-size: 1.6rem;
  width: 100%;
  @media (min-width: 490px) {
    width: 100%;
    font-size: 2rem;
  }
  @media (min-width: 1276px) {
    width: 100%;
    font-size: 2.5rem;
  }
`;

export const Imagem = styled.img`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw; // largura da tela
  height: 100vh; // altura da tela
  object-fit: cover; // cobre a tela proporcionalmente
  z-index: 0;
`;

export const CardStyle = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 20px;
  width: 700px;

  @media (max-width: 768px) {
    width: 100%;
    margin: 10px;
    height: auto;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }

  @media (max-width: 480px) {
    width: 100%;
    margin: 0px;
    height: auto;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }
`;
export const StepsStyle = styled(Steps)`
  width: 100%;

  @media (max-width: 768px) {
    .ant-steps-horizontal.ant-steps {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .ant-steps-item {
      flex: 1 1 25%;
      text-align: center;
    }
  }
`;
export const ContainerButton = styled.div`
  width: 50%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 20px;

  @media (max-width: 480px) {
    margin-top: 25px;
    margin-bottom: 50px;
  }
`;

export const ContainerPeriodo = styled.div`
  width: 100%;
  height: 100%;
  flex-direction: column;
  // grid-row-start: 2;
  // grid-column: span 3;
  // border: 2px solid brown;
  display: flex;

  // grid-template: 5% 1fr 1fr/ 100%;
  justify-content: center;
  align-items: center;
  // padding: 0;
  // @media (max-width: 768px) {
  // }

  // #checkIn {
  //   width: 90%;
  //   height: 20%;
  //   font-size: 1rem;
  //   color: ${Globais.CorAzulBackGround};
  //   border: 1px solid ${Globais.CorAzulBackGround};
  //   border-radius: 10px;
  //   margin-left: 0.5rem;
  //   text-align: center;
  //   padding-left: 0.5rem;
  //   &:hover {
  //     cursor: pointer;
  //   }
  //   @media (min-width: 350px) {
  //     width: 70%;
  //   }
  //   @media (min-width: 400px) {
  //     width: 60%;
  //   }
  //   @media (min-width: 450px) {
  //     width: 50%;
  //   }
  // }

  // #checkOut {
  //   width: 90%;
  //   height: 20%;
  //   font-size: 1rem;
  //   color: ${Globais.CorAzulBackGround};
  //   border: 1px solid ${Globais.CorAzulBackGround};
  //   border-radius: 10px;
  //   margin-left: 0.5rem;
  //   text-align: center;
  //   padding-left: 0.5rem;
  //   &:hover {
  //     cursor: pointer;
  //   }
  //   @media (min-width: 350px) {
  //     width: 70%;
  //   }
  //   @media (min-width: 400px) {
  //     width: 60%;
  //   }
  //   @media (min-width: 450px) {
  //     width: 50%;
  //   }
  // }

  // #divCheckIn {
  //   grid-column-start: 1;
  //   grid-row-start: 2;

  //   width: 100%;
  //   height: 100%;
  //   display: flex;

  //   justify-content: flex-start;
  //   align-items: center;

  //   flex-direction: column;
  // }
  // #divCheckOut {
  //   grid-column-start: 2;
  //   grid-row-start: 2;

  //   width: 100%;
  //   height: 100%;
  //   display: flex;
  //   justify-content: flex-start;

  //   align-items: center;
  //   flex-direction: column;
  // }
  // #botoesData {
  //   grid-column-start: 3;
  //   grid-row-start: 2;
  //   display: flex;
  //   justify-content: flex-start;

  //   align-items: center;
  //   width: 100%;
  //   height: 100%;
  // }
`;

export const ContainerCheckin = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 1rem;
`;
export const ContainerCheckOut = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
`;

export const TituloPeriodo = styled.h4`
  color: ${Globais.CorAzulBackGround};
  font-weight: 100;
  margin-bottom: 1rem;
`;

export const Label = styled.label`
  font-weight: 600;
  margin-bottom: 0.5rem;
  margin-top: 1.2rem;
  color: #444;
`;
export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
`;

export const CheckboxLabel = styled.label`
  font-weight: 400;
  margin-bottom: 0.5rem;
  color: #444;

  input {
    margin-right: 0.5rem;
  }
`;

export const ContainerTipoInteresse = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const ContainerCapacidade = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const ContainerSelecaoTipoInteresse = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const ContainerTipo = styled.div`
  display: flex;
  margin: 0.5rem;
  justify-content: center;
  align-items: center;
`;

export const ContainerValorTipoInteresse = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
export const Input = styled.input`
  width: 100%;
  padding: 0.9rem;
  margin-bottom: 1.5rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 1rem;
`;
